/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Hero_TitleInputs */

const en_st_hero_title = /** @type {(inputs: St_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep Studio — for agencies & freelancers`)
};

const id_st_hero_title = /** @type {(inputs: St_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep Studio — untuk agensi & freelancer`)
};

/**
* | output |
* | --- |
* | "Bystep Studio — for agencies & freelancers" |
*
* @param {St_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_hero_title = /** @type {((inputs?: St_Hero_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Hero_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_hero_title(inputs)
	return en_st_hero_title(inputs)
});